import { useMemo } from 'react';
import type { UseFeedSortingOptions } from '../types';
import type { QuestionCacheItem } from '@lib/cache/questions';

/**
 * Client-side feed processing.
 * Non-bookmarked sorting is now server-side.
 * Only bookmarked filtering remains client-side (it changes the result set, not just order).
 */
export function useFeedSorting({
  questions,
  sortBy,
  isAuthenticated,
}: UseFeedSortingOptions): QuestionCacheItem[] {
  return useMemo(() => {
    if (questions.length === 0) return [];

    if (sortBy === 'bookmarked') {
      if (!isAuthenticated) return [];
      return [...questions]
        .filter(q => q.user_has_bookmarked)
        .sort((a, b) => {
          const bTime = b.created_at ? new Date(b.created_at).getTime() : 0;
          const aTime = a.created_at ? new Date(a.created_at).getTime() : 0;
          return bTime - aTime;
        });
    }

    // All other sorts handled server-side — return as-is
    return questions;
  }, [questions, sortBy, isAuthenticated]);
}
